module.exports = __webpack_public_path__ + "static/media/client-logo-2.6505eb8e.jpg";